import type {
  ProfileProps,
  UserPartnerCompanyProps,
} from '@services/UserService';

import type { ExtraUserPartnerCompanyProps } from '../types';

export const updateRemovedProfiles = (
  partnerCompany: ExtraUserPartnerCompanyProps,
  selectedProfiles: ProfileProps[],
): UserPartnerCompanyProps => {
  const profileStillChecked = selectedProfiles?.find(
    selectedProfile => selectedProfile?.id === partnerCompany?.profile?.id,
  );

  if (
    !partnerCompany?.hasAccess ||
    !partnerCompany?.profile ||
    profileStillChecked
  ) {
    return partnerCompany;
  }
  return {
    ...partnerCompany,
    hasAccess: false,
    profile: undefined,
  };
};
